module.exports = __webpack_public_path__ + "static/media/la-gran-campana-min.576da0a1.png";